// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const AlignCenterIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 0a1 1 0 011 1v5h2a3 3 0 013 3v6a3 3 0 01-3 3h-2v5a1 1 0 11-2 0v-5H9a3 3 0 01-3-3V9a3 3 0 013-3h2V1a1 1 0 011-1zM9 8a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V9a1 1 0 00-1-1H9z"/></svg>'} />;

AlignCenterIcon.displayName = 'AlignCenterIcon';

export default AlignCenterIcon;
